// @ts-nocheck: converted from JS

import Colony from '@/components/Colony';

export default Colony;
